import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['extra', 'toggle', 'toggleText']

  toggle() {
    const isOpen = this.toggleTarget.classList.toggle('is-open')

    this.extraTargets.forEach(el => {
      el.classList.toggle('case-sticky__item--visible', isOpen)
    })

    this.toggleTextTarget.textContent = isOpen ? 'See less' : 'See all'
  }
}
